import React from 'react';

import styles from './SelectedStudyPCN.module.scss';

export const SelectedStudyPCN = ({ studyName, pcn }) => {
  return (
    <div className={styles['selected-study-pcn__container']}>
      <span className={styles['selected-study-pcn__study-name']} data-testid="protocol-filter-study-name-label">
        {studyName}
      </span>
      <span
        className={styles['selected-study-pcn__pcn-name']}
        data-testid="protocol-filter-study-pcn-label"
      >{` (${pcn})`}</span>
    </div>
  );
};
